import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PATHS } from '../config/paths.config';
import {
  AuthGuardService,
  ChangeTemporalPasswordComponent,
  ChangeTemporalPasswordGuardService,
  LoginComponent,
  PasswordRestoreComponent,
  RequirePasswordChangeComponent,
} from '@foxeet/feature/auth';

const routes: Routes = [
  {
    path: `${PATHS.LOGIN}`,
    component: LoginComponent,
  },
  {
    path: `${PATHS.CHANGE_TEMPORAL_PASSWORD}`,
    component: ChangeTemporalPasswordComponent,
    canActivate: [ChangeTemporalPasswordGuardService],
  },
  {
    path: `${PATHS.REQUIRE_PASSWORD_CHANGE}`,
    component: RequirePasswordChangeComponent,
  },
  {
    path: `${PATHS.PASSWORD_RESTORE}`,
    component: PasswordRestoreComponent,
  },
  {
    path: '',
    loadChildren: () => import('./modules/modules.module').then((module) => module.ModulesModule),
    // canLoad: [AccountCanLoad],
    canActivate: [AuthGuardService],
    data: { platform: 'ivforce' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
